import { useState, useCallback, useMemo } from "react";
import { toast } from "react-toastify";
import downloadPrescriptionPdf, {
  PdfDownloadStatus,
} from "../service/prescriptionPdf";
import downloadBlob from "../utils/downloadBlob";

const DEFAULT_ERROR_MESSAGE =
  "Não foi possível fazer o download. Tente novamente.";

const DOWNLOAD_ERROR_MESSAGE = {
  [PdfDownloadStatus.Unavailable]: "PDF indisponível para esta prescrição.",
  [PdfDownloadStatus.ServiceUnavailable]:
    "Serviço de receitas instável no momento. Aguarde alguns instantes e tente novamente.",
  [PdfDownloadStatus.Error]: DEFAULT_ERROR_MESSAGE,
};

const usePrescriptionDownload = (prescription) => {
  const {
    id: idPrescription,
    token,
    historyOffset,
    document: prescriptionDocument,
  } = prescription;

  const pdfAccess = prescriptionDocument?.pdf_access;
  const [loading, setLoading] = useState(false);

  const download = useCallback(async () => {
    if (!pdfAccess) {
      return;
    }

    setLoading(true);

    try {
      const { status, blob } = await downloadPrescriptionPdf({
        idPrescription,
        offset: historyOffset,
      });

      if (status === PdfDownloadStatus.Success) {
        downloadBlob(blob, `prescricao-${token}`);
        return;
      }

      toast.error(DOWNLOAD_ERROR_MESSAGE[status] ?? DEFAULT_ERROR_MESSAGE);
    } finally {
      setLoading(false);
    }
  }, [pdfAccess, idPrescription, historyOffset, token]);

  const buttonProps = useMemo(
    () => ({
      handleClick: download,
      loading,
      disabled: loading || !pdfAccess,
      title: !pdfAccess ? "PDF indisponível para esta prescrição" : undefined,
    }),
    [download, loading, pdfAccess]
  );

  return { pdfAccess, buttonProps };
};

export default usePrescriptionDownload;
